import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";

const faqs = [
  {
    question: "Is MuskConnect Pro affiliated with Elon Musk or his companies?",
    answer:
      "MuskConnect Pro is a community fan hub celebrating Elon Musk's ventures. It is not officially affiliated with Tesla, SpaceX, or Elon Musk personally, but operated by dedicated fans.",
  },
  {
    question: "How secure is my personal and financial information?",
    answer:
      "We use industry-standard encryption (TLS 1.3), secure authentication, and comply with GDPR. Financial data is handled through verified payment processors. We never store sensitive payment details on our servers.",
  },
  {
    question: "What is the Bitcoin rewards program?",
    answer:
      "Our investment program offers quarterly Bitcoin rewards to verified members based on their investment tier. Rewards are distributed transparently and tracked on your personal dashboard. This is educational content, not financial advice.",
  },
  {
    question: "Can I withdraw my investment anytime?",
    answer:
      "Investment terms vary by tier. Please review the complete terms of service during signup. We recommend consulting a financial advisor before investing.",
  },
  {
    question: "How do I report a security issue?",
    answer:
      "Email security@muskconnectpro.com with details. Do not publicly disclose vulnerabilities. We take all reports seriously and offer responsible disclosure rewards.",
  },
  {
    question: "Is there a community chatroom?",
    answer:
      "Yes! Verified members gain access to exclusive real-time chat, message boards, and live Q&A sessions with industry experts and fellow enthusiasts.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept PayPal, Bitcoin/Crypto wallets, Cash App, bank transfers, and credit/debit cards. Payment methods vary by region and your verification level.",
  },
  {
    question: "How often are updates posted?",
    answer:
      "We post exclusive updates daily from verified Tesla, SpaceX, and Elon Musk project sources. Verified members receive real-time notifications.",
  },
];

// ... existing code ...
export default function FAQ() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.06,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: [0.4, 0, 0.2, 1] },
    },
  };
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
    >
      <Accordion type="single" collapsible className="space-y-0">
        {faqs.map((faq, idx) => (
          <motion.div
            key={idx}
            variants={itemVariants}
          >
            <AccordionItem
              value={`item-${idx}`}
              className="border border-border data-[state=open]:bg-card/50 hover:border-foreground/50 transition-colors"
            >
              <AccordionTrigger className="text-foreground hover:opacity-70 font-medium py-5 px-6 transition-opacity">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-5 px-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          </motion.div>
        ))}
      </Accordion>
    </motion.div>
  );
}